import React from "react";
import { connectSearchBox } from "react-instantsearch-dom";

export default connectSearchBox(({ refine, className, inputRef, currentRefinement }) => (
  <input
    id="learning-center-search"
    name="learning-center-search"
    className={className}
    ref={inputRef}
    value={currentRefinement}
    type="search"
    placeholder="Search"
    aria-label="Search learning center content"
    autoComplete="off"
    onChange={(e) => refine(e.target.value)}
  />
));
